export const validatePhoneNumber = (phoneNumber) => {
    const patterns = {
        'Georgia': /^(\+995)?(5\d{8})$/,
        'Kazakhstan': /^(\+7)?(\d{10})$/,
        'Korea': /^(\+82)?(01[016789]-?\d{3,4}-?\d{4})$/,
        'Russia': /^(\+7)?(\d{10})$/,
        'Armenia': /^(\+374)?(77|91|96|98|99|41|43|44|49|55|95|97)-?\d{6}$/,
        'Azerbaijan': /^(\+994)?(40|50|51|55|70|77|99)\d{7}$/,
        'Turkey': /^(\+90)?(5\d{9})$/,
        'Czech': /^(\+420)?\d{9}$/,
        'Belarus': /^(\+375)?(25|29|33|44)\d{7}$/,
        'Germany': /^(\+49)?([1-9]\d{1,14})$/,
        'Ukraine': /^(\+380)?(39|50|63|66|67|68|96|97|98|99)\d{7}$/,
        'Israel': /^(?:\+9725\d{8}|05\d{8})$/,
    };

    const isValidNumber = Object.values(patterns).some(pattern => pattern.test(phoneNumber));
    return isValidNumber;
};
